import React, { useState, useEffect } from 'react'
import DropFileInput from '../drop-file-input/DropFileInput';
import { ethers } from 'ethers';
import keccak256 from 'keccak256';
import MerkleTree from 'merkletreejs';
import {Box,Paper,Button, Typography, TextField, CircularProgress, colors } from '@mui/material'
import { Cancel, DeckOutlined, ImportContactsSharp } from '@mui/icons-material';
import DoneIcon from '@mui/icons-material/Done';
import ClaimListItem from './ClaimListItem';

const refugeecampABI = require("./../../refugeecampABI.json");
// const CONTRACT_ADDRESS = "0xD096f5059ccd1ae2759dC893E80FB43E988Af896"
const CONTRACT_ADDRESS = "0x91013c098C93cb2E64189a8c4F6D97D4c9972907"

//const CONTRACT_ADDRESS = "0x34dd52b85Fa8f49A0BE1fC6fEE1DF53790c3c060"

window.Buffer = window.Buffer || require("buffer").Buffer;

const ProveClaim = (props) => {
  const [claimValue, setClaimValue] = useState("");
  const [file, setFile] = useState({});
  const [keys, setKeys] = useState(props.keys);
  const [claim, setClaim] = useState(-1);
  const [value,setValue] =useState('')
  const [isProofTrue, setIsProofTrue] = useState();



  const onFileChange = async(files) => {
    const fileReader = new FileReader()
    fileReader.readAsText(files[0])
    fileReader.onload = e => {
      const f = JSON.parse(e.target.result)
      setFile(f)
      //setKeys(Object.keys(f))
      console.log(Object.keys(f))
    }
  }

  const proveClaim =async (claimParam, claimParamValue) => {
    claimParam = keys.findIndex((entry)=>entry==claimParam)
    // creating PII
    
    if(file[keys[claimParam]] != claimParamValue) {
      setIsProofTrue(false)
      return false
    }
    var PIIs = []
    for(var key in file){
      const PII = "" + key + "__" + file[key]
      PIIs.push(PII);
    }
    const leafNodes = PIIs.map((PII) => keccak256(PII));
    const merkleTree = new MerkleTree(leafNodes, keccak256, {sortPairs : true });
    const proof = merkleTree.getHexProof(leafNodes[claimParam])
    console.log("got proof")
    console.log(proof)
    
    console.log("0x" + merkleTree.getRoot().toString("hex"))
    let retVal
    retVal= await sendProofToBlockChain(proof, leafNodes[claimParam])
    return retVal

  }

  const sendProofToBlockChain = async(proof, leaf) => {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      console.log("0x" + leaf.toString("hex"))
      await provider.send("eth_requestAccounts", []);
      const hehe = await provider.getCode(CONTRACT_ADDRESS)
      console.log("Address",hehe)
      const signer = await provider.getSigner();
      const refugeecamp = new ethers.Contract(CONTRACT_ADDRESS, refugeecampABI, signer);
      const attestation = await refugeecamp.getAttestation(proof, leaf);
      console.log(attestation)
      setIsProofTrue(attestation);
      return attestation
  }

  return (

      <Box sx={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",width:"80vw",minHeight:"120vh",marginTop:{xs:"5vh",md:"5vh"},marginBottom:{xs:"10vh",md:"5vh"},padding:"5vh 0"}}>
        
          <Typography color="primary" variant="h4">Prove A Claim</Typography>
          {/*<select value = {claim}onChange={(e) => setClaim(e.target.value)}>
            {
              keys.map((k, ind)=> <option value={ind}>{k}</option>)
            }
          </select>*/}
          <Box sx={{width:"75vw"}}>
            <Typography>Upload your json file here</Typography>
            <DropFileInput onFileChange={(files) => onFileChange(files)}/> 
          </Box>
           
          <Box sx={{marginBottom:"5vh"}}>
          
            {keys.map( 
              (k,ind)=><ClaimListItem key={ind} k={k} proveClaim={proveClaim} /> 
            )
          }
          </Box>
         
          {/*<button onClick={()=>{proveClaim(claim, claimValue)}}><b>GET PROOF</b></button>*/}
          {/*isProofTrue == null ? <></>:<h1>{isProofTrue.toString()}</h1>*/}
      </Box>
    
  )
}

export default ProveClaim